"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2451],{

/***/ 66602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LK": function() { return /* binding */ useGetCompanyQuery; },
/* harmony export */   "f4": function() { return /* binding */ useCreateCompanyMutation; },
/* harmony export */   "lj": function() { return /* binding */ companyService; }
/* harmony export */ });
/* unused harmony exports createCompany, getCompany */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10092);
/* harmony import */ var common_types_responses__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7061);
/* harmony import */ var common_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24125);
/* harmony import */ var _useSubscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64357);
/* harmony import */ var common_utils_urls_param__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57384);
/* harmony import */ var common_transformPagination__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50135);










var companyService = common_service__WEBPACK_IMPORTED_MODULE_1__/* .service.enhanceEndpoints */ .Xn.enhanceEndpoints({
    addTagTypes: [
        "Company",
        "Subscription"
    ]
}).injectEndpoints({
    endpoints: function(builder) {
        return {
            createCompany: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "Company"
                    }
                ],
                queryFn: function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(query, _1, _2, baseQuery) {
                        var subscription, ref, data, error;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    subscription = (0,common_types_responses__WEBPACK_IMPORTED_MODULE_0__/* .convertSubscriptionToAPI */ .Up)(query.subscription);
                                    return [
                                        4,
                                        baseQuery({
                                            body: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, subscription), {
                                                groups: query.groups,
                                                members: []
                                            }),
                                            method: "POST",
                                            url: "partners/company"
                                        })
                                    ];
                                case 1:
                                    ref = _state.sent(), data = ref.data, error = ref.error;
                                    return [
                                        4,
                                        (0,_useSubscription__WEBPACK_IMPORTED_MODULE_2__/* .updateMembers */ .q0)(data.company_id, data.subscription_id, query.membersToRemove, query.membersVeriffToRemove, query.subscription.members, query.subscription.membersVeriff)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2,
                                        {
                                            data: data,
                                            error: error
                                        }
                                    ];
                            }
                        });
                    });
                    return function(query, _1, _2, baseQuery) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            getCompany: builder.query({
                providesTags: function(res, _, req) {
                    return [
                        {
                            id: req.id,
                            type: "Company"
                        }
                    ];
                },
                query: function(_param) {
                    var id = _param.id, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
                        "id"
                    ]);
                    return {
                        url: "partners/subscriptions?".concat((0,common_utils_urls_param__WEBPACK_IMPORTED_MODULE_8__/* .toParam */ .i)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            company_id: id
                        }, rest)))
                    };
                },
                transformResponse: function(res, _, req) {
                    return (0,common_transformPagination__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(req, res);
                }
            })
        };
    }
});
function createCompany(store, data, options) {
    return _createCompany.apply(this, arguments);
}
function _createCompany() {
    _createCompany = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(companyService.endpoints.createCompany.initiate(data, options))
            ];
        });
    });
    return _createCompany.apply(this, arguments);
}
function getCompany(store, data, options) {
    return _getCompany.apply(this, arguments);
}
function _getCompany() {
    _getCompany = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(companyService.endpoints.getCompany.initiate(data, options))
            ];
        });
    });
    return _getCompany.apply(this, arguments);
}
// END OF FUNCTION_EXPORTS
var useCreateCompanyMutation = companyService /* Usage examples:
const { data, isLoading } = useGetCompanyQuery({ id: 2 }, {}) //get hook
const [createCompany, { isLoading, data, isSuccess }] = useCreateCompanyMutation() //create hook
companyService.endpoints.getCompany.select({id: 2})(store.getState()) //access data from any function
*/ .useCreateCompanyMutation, useGetCompanyQuery = companyService.useGetCompanyQuery;


/***/ }),

/***/ 64357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pI": function() { return /* binding */ getSubscription; },
  "tJ": function() { return /* binding */ getSubscriptions; },
  "AB": function() { return /* binding */ subscriptionService; },
  "q0": function() { return /* binding */ updateMembers; },
  "ho": function() { return /* binding */ useCreateSubscriptionMutation; },
  "xu": function() { return /* binding */ useGetSubscriptionQuery; },
  "Tb": function() { return /* binding */ useGetSubscriptionsQuery; },
  "A1": function() { return /* binding */ useUpdateSubscriptionMutation; }
});

// UNUSED EXPORTS: createSubscription, updateSubscription

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./common/types/responses.ts
var responses = __webpack_require__(7061);
// EXTERNAL MODULE: ./common/service.ts + 7 modules
var service = __webpack_require__(24125);
// EXTERNAL MODULE: ./common/transformPagination.ts
var transformPagination = __webpack_require__(50135);
// EXTERNAL MODULE: ./common/utils/urls/param.ts + 1 modules
var param = __webpack_require__(57384);
// EXTERNAL MODULE: ./common/services/useCompany.ts
var useCompany = __webpack_require__(66602);
// EXTERNAL MODULE: ./common/store.ts + 3 modules
var store = __webpack_require__(71185);
// EXTERNAL MODULE: ./common/toFormData.ts
var toFormData = __webpack_require__(86773);
;// CONCATENATED MODULE: ./common/services/useUbo.ts









var uboService = service/* service.enhanceEndpoints */.Xn.enhanceEndpoints({
    addTagTypes: [
        "Ubo"
    ]
}).injectEndpoints({
    endpoints: function(builder) {
        return {
            createUbo: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "Ubo"
                    }
                ],
                query: function(query) {
                    return {
                        body: (0,toFormData/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query.data), {
                            documents: undefined
                        })),
                        method: "POST",
                        url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.subscription_id, "/identifications")
                    };
                }
            }),
            deleteUbo: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "Ubo"
                    }
                ],
                query: function(query) {
                    return {
                        body: {},
                        method: "DELETE",
                        url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.subscription_id, "/identifications/").concat(query.id)
                    };
                },
                transformResponse: function(res) {
                    (0,store/* getStore */.b)().dispatch(useCompany/* companyService.util.invalidateTags */.lj.util.invalidateTags([
                        "Company"
                    ]));
                    (0,store/* getStore */.b)().dispatch(subscriptionService.util.invalidateTags([
                        "Subscription"
                    ]));
                    return res;
                }
            }),
            getUbos: builder.query({
                providesTags: function(res) {
                    return [
                        {
                            id: res === null || res === void 0 ? void 0 : res.id,
                            type: "Ubo"
                        }
                    ];
                },
                query: function(query) {
                    return {
                        url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.subscription_id, "/identifications")
                    };
                },
                transformResponse: function(res) {
                    return res;
                }
            }),
            updateUbo: builder.mutation({
                invalidatesTags: function(res) {
                    return [
                        {
                            id: "LIST",
                            type: "Ubo"
                        },
                        {
                            id: res === null || res === void 0 ? void 0 : res.id,
                            type: "Ubo"
                        }, 
                    ];
                },
                query: function(query) {
                    return {
                        body: (0,toFormData/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query.data), {
                            documents: undefined
                        })),
                        method: "PUT",
                        url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.subscription_id, "/identifications/").concat(query.data.id)
                    };
                },
                transformResponse: function(res) {
                    (0,store/* getStore */.b)().dispatch(useCompany/* companyService.util.invalidateTags */.lj.util.invalidateTags([
                        "Company"
                    ]));
                    (0,store/* getStore */.b)().dispatch(subscriptionService.util.invalidateTags([
                        "Subscription"
                    ]));
                    return res;
                }
            })
        };
    }
});
function createUbo(store, data, options) {
    return _createUbo.apply(this, arguments);
}
function _createUbo() {
    _createUbo = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(uboService.endpoints.createUbo.initiate(data, options))
            ];
        });
    });
    return _createUbo.apply(this, arguments);
}
function deleteUbo(store, data, options) {
    return _deleteUbo.apply(this, arguments);
}
function _deleteUbo() {
    _deleteUbo = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(uboService.endpoints.deleteUbo.initiate(data, options))
            ];
        });
    });
    return _deleteUbo.apply(this, arguments);
}
function getUbos(store, data, options) {
    return _getUbos.apply(this, arguments);
}
function _getUbos() {
    _getUbos = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(uboService.endpoints.getUbos.initiate(data, options))
            ];
        });
    });
    return _getUbos.apply(this, arguments);
}
function updateUbo(store, data, options) {
    return _updateUbo.apply(this, arguments);
}
function _updateUbo() {
    _updateUbo = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(uboService.endpoints.updateUbo.initiate(data, options))
            ];
        });
    });
    return _updateUbo.apply(this, arguments);
}
// END OF FUNCTION_EXPORTS
var useCreateUboMutation = uboService /* Usage examples:
const { data, isLoading } = usegetUbosQuery({ id: 2 }, {}) //get hook
const [createUbo, { isLoading, data, isSuccess }] = useCreateUboMutation() //create hook
uboService.endpoints.getUbos.select({id: 2})(store.getState()) //access data from any function
*/ .useCreateUboMutation, useDeleteUboMutation = uboService.useDeleteUboMutation, useGetUbosQuery = uboService.useGetUbosQuery, useUpdateUboMutation = uboService.useUpdateUboMutation;

;// CONCATENATED MODULE: ./common/services/useUboVeriff.ts






var uboVeriffService = service/* service.enhanceEndpoints */.Xn.enhanceEndpoints({
    addTagTypes: [
        "UboVeriff"
    ]
}).injectEndpoints({
    endpoints: function(builder) {
        return {
            createUboVeriff: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "UboVeriff"
                    }
                ],
                query: function(query) {
                    return {
                        body: query.data,
                        method: "POST",
                        url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.subscription_id, "/verifications")
                    };
                }
            }),
            deleteUboVeriff: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "UboVeriff"
                    }
                ],
                query: function(query) {
                    return {
                        body: query,
                        method: "DELETE",
                        url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.subscription_id, "/verifications/").concat(query.id)
                    };
                },
                transformResponse: function(res) {
                    (0,store/* getStore */.b)().dispatch(useCompany/* companyService.util.invalidateTags */.lj.util.invalidateTags([
                        "Company"
                    ]));
                    (0,store/* getStore */.b)().dispatch(subscriptionService.util.invalidateTags([
                        "Subscription"
                    ]));
                    return res;
                }
            }),
            getUboVeriffs: builder.query({
                providesTags: [
                    {
                        id: "LIST",
                        type: "UboVeriff"
                    }
                ],
                query: function(query) {
                    return {
                        url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.subscription_id, "/verifications")
                    };
                }
            }),
            updateUboVeriff: builder.mutation({
                invalidatesTags: function(res) {
                    return [
                        {
                            id: "LIST",
                            type: "UboVeriff"
                        },
                        {
                            id: res === null || res === void 0 ? void 0 : res.id,
                            type: "UboVeriff"
                        }, 
                    ];
                },
                query: function(query) {
                    return {
                        body: query.data,
                        method: "PUT",
                        url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.subscription_id, "/verifications/").concat(query.data.id)
                    };
                },
                transformResponse: function(res) {
                    (0,store/* getStore */.b)().dispatch(useCompany/* companyService.util.invalidateTags */.lj.util.invalidateTags([
                        "Company"
                    ]));
                    (0,store/* getStore */.b)().dispatch(subscriptionService.util.invalidateTags([
                        "Subscription"
                    ]));
                    return res;
                }
            })
        };
    }
});
function createUboVeriff(store, data, options) {
    return _createUboVeriff.apply(this, arguments);
}
function _createUboVeriff() {
    _createUboVeriff = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(uboVeriffService.endpoints.createUboVeriff.initiate(data, options))
            ];
        });
    });
    return _createUboVeriff.apply(this, arguments);
}
function deleteUboVeriff(store, data, options) {
    return _deleteUboVeriff.apply(this, arguments);
}
function _deleteUboVeriff() {
    _deleteUboVeriff = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(uboVeriffService.endpoints.deleteUboVeriff.initiate(data, options))
            ];
        });
    });
    return _deleteUboVeriff.apply(this, arguments);
}
function updateUboVeriff(store, data, options) {
    return _updateUboVeriff.apply(this, arguments);
}
function _updateUboVeriff() {
    _updateUboVeriff = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(uboVeriffService.endpoints.updateUboVeriff.initiate(data, options))
            ];
        });
    });
    return _updateUboVeriff.apply(this, arguments);
}
function getUboVeriffs(store, data, options) {
    return _getUboVeriffs.apply(this, arguments);
}
function _getUboVeriffs() {
    _getUboVeriffs = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(uboVeriffService.endpoints.getUboVeriffs.initiate(data, options))
            ];
        });
    });
    return _getUboVeriffs.apply(this, arguments);
}
// END OF FUNCTION_EXPORTS
var useCreateUboVeriffMutation = uboVeriffService /* Usage examples:
const { data, isLoading } = useGetUboVeriffQuery({ id: 2 }, {}) //get hook
const [createUboVeriff, { isLoading, data, isSuccess }] = useCreateUboVeriffMutation() //create hook
uboVeriffService.endpoints.getUboVeriff.select({id: 2})(store.getState()) //access data from any function
*/ .useCreateUboVeriffMutation, useDeleteUboVeriffMutation = uboVeriffService.useDeleteUboVeriffMutation, useGetUboVeriffsQuery = uboVeriffService.useGetUboVeriffsQuery, useUpdateUboVeriffMutation = uboVeriffService.useUpdateUboVeriffMutation;

;// CONCATENATED MODULE: ./common/services/useSubscription.ts












var updateMembers = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(companyId, subscriptionId, membersToRemove, membersVeriffToRemove, members, membersVeriff) {
        var deletes, updates;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all((membersToRemove || []).map(function(v) {
                            return deleteUbo((0,store/* getStore */.b)(), {
                                company_id: companyId,
                                id: "".concat(v),
                                subscription_id: subscriptionId
                            });
                        }).concat((membersVeriffToRemove || []).map(function(v) {
                            return deleteUboVeriff((0,store/* getStore */.b)(), {
                                company_id: companyId,
                                id: "".concat(v),
                                subscription_id: subscriptionId
                            });
                        })))
                    ];
                case 1:
                    deletes = _state.sent();
                    return [
                        4,
                        Promise.all((membersVeriff || []).map(function(v) {
                            return v.id ? updateUboVeriff((0,store/* getStore */.b)(), {
                                company_id: companyId,
                                data: v,
                                subscription_id: subscriptionId
                            }) : createUboVeriff((0,store/* getStore */.b)(), {
                                company_id: companyId,
                                data: v,
                                subscription_id: subscriptionId
                            });
                        }).concat((members || []).map(function(v) {
                            return v.id ? updateUbo((0,store/* getStore */.b)(), {
                                company_id: companyId,
                                data: v,
                                subscription_id: subscriptionId
                            }) : createUbo((0,store/* getStore */.b)(), {
                                company_id: companyId,
                                data: v,
                                subscription_id: subscriptionId
                            });
                        })))
                    ];
                case 2:
                    updates = _state.sent();
                    return [
                        2,
                        updates.concat(deletes)
                    ];
            }
        });
    });
    return function updateMembers(companyId, subscriptionId, membersToRemove, membersVeriffToRemove, members, membersVeriff) {
        return _ref.apply(this, arguments);
    };
}();
var subscriptionService = service/* service.enhanceEndpoints */.Xn.enhanceEndpoints({
    addTagTypes: [
        "Subscription"
    ]
}).injectEndpoints({
    endpoints: function(builder) {
        return {
            createSubscription: builder.mutation({
                invalidatesTags: [
                    {
                        id: "LIST",
                        type: "Subscription"
                    }
                ],
                queryFn: function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(query, _1, _2, baseQuery) {
                        var ref, data, error;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        baseQuery({
                                            body: (0,responses/* convertSubscriptionToAPI */.Up)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query.subscription), {
                                                members: []
                                            })),
                                            method: "POST",
                                            url: "partners/company/".concat(query.company_id, "/subscriptions")
                                        })
                                    ];
                                case 1:
                                    ref = _state.sent(), data = ref.data, error = ref.error;
                                    return [
                                        4,
                                        updateMembers(data.company_id, data.subscription_id, query.membersToRemove, query.membersVeriffToRemove, query.subscription.members, query.subscription.membersVeriff)
                                    ];
                                case 2:
                                    _state.sent();
                                    (0,store/* getStore */.b)().dispatch(useCompany/* companyService.util.invalidateTags */.lj.util.invalidateTags([
                                        "Company"
                                    ]));
                                    return [
                                        2,
                                        {
                                            data: data,
                                            error: error
                                        }
                                    ];
                            }
                        });
                    });
                    return function(query, _1, _2, baseQuery) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            getSubscription: builder.query({
                providesTags: function(res) {
                    return [
                        {
                            id: res === null || res === void 0 ? void 0 : res.id,
                            type: "Subscription"
                        }
                    ];
                },
                query: function(query) {
                    return {
                        url: "partners/company/".concat(query.customerId, "/subscriptions/").concat(query.id)
                    };
                },
                transformResponse: function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(res, _, req) {
                        var data, ref, veriffData;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getUbos((0,store/* getStore */.b)(), {
                                            company_id: req.customerId,
                                            subscription_id: req.id
                                        }, {
                                            forceRefetch: true
                                        })
                                    ];
                                case 1:
                                    data = _state.sent().data;
                                    return [
                                        4,
                                        getUboVeriffs((0,store/* getStore */.b)(), {
                                            company_id: req.customerId,
                                            subscription_id: req.id
                                        }, {
                                            forceRefetch: true
                                        })
                                    ];
                                case 2:
                                    ref = _state.sent(), veriffData = ref.data;
                                    return [
                                        2,
                                        (0,responses/* convertAPISubscriptionToNormal */.ji)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, res), {
                                            members: data.results,
                                            membersVeriff: veriffData.results
                                        }))
                                    ];
                            }
                        });
                    });
                    return function(res, _, req) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            getSubscriptions: builder.query({
                providesTags: [
                    {
                        id: "LIST",
                        type: "Subscription"
                    }
                ],
                query: function(q) {
                    return {
                        responseHandler: q.export ? "text" : "json",
                        url: "partners/subscriptions?".concat((0,param/* toParam */.i)(q))
                    };
                },
                transformResponse: function(res, _, req) {
                    if (req.export) {
                        return res;
                    }
                    return (0,transformPagination/* default */.Z)(req, res);
                }
            }),
            updateSubscription: builder.mutation({
                invalidatesTags: function(res) {
                    return [
                        {
                            id: "LIST",
                            type: "Subscription"
                        },
                        {
                            id: res === null || res === void 0 ? void 0 : res.id,
                            type: "Subscription"
                        }, 
                    ];
                },
                queryFn: function() {
                    var _ref = (0,src_async_to_generator/* default */.Z)(function(query, _1, _2, baseQuery) {
                        var newData, body, ref, data, error;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    (0,store/* getStore */.b)().dispatch(useCompany/* companyService.util.invalidateTags */.lj.util.invalidateTags([
                                        "Company"
                                    ]));
                                    newData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query.subscription), {
                                        members: []
                                    });
                                    body = (0,responses/* convertSubscriptionToAPI */.Up)(newData);
                                    return [
                                        4,
                                        baseQuery({
                                            body: body,
                                            method: "PUT",
                                            url: "partners/company/".concat(query.company_id, "/subscriptions/").concat(query.subscription.id)
                                        })
                                    ];
                                case 1:
                                    ref = _state.sent(), data = ref.data, error = ref.error;
                                    return [
                                        4,
                                        updateMembers("".concat(query.company_id), "".concat(query.subscription.id), query.membersToRemove, query.membersVeriffToRemove, query.subscription.members, query.subscription.membersVeriff)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2,
                                        {
                                            data: data,
                                            error: error
                                        }
                                    ];
                            }
                        });
                    });
                    return function(query, _1, _2, baseQuery) {
                        return _ref.apply(this, arguments);
                    };
                }()
            })
        };
    }
});
function getSubscriptions(store, data, options) {
    return _getSubscriptions.apply(this, arguments);
}
function _getSubscriptions() {
    _getSubscriptions = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(subscriptionService.endpoints.getSubscriptions.initiate(data, options))
            ];
        });
    });
    return _getSubscriptions.apply(this, arguments);
}
function createSubscription(store, data, options) {
    return _createSubscription.apply(this, arguments);
}
function _createSubscription() {
    _createSubscription = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(subscriptionService.endpoints.createSubscription.initiate(data, options))
            ];
        });
    });
    return _createSubscription.apply(this, arguments);
}
function updateSubscription(store, data, options) {
    return _updateSubscription.apply(this, arguments);
}
function _updateSubscription() {
    _updateSubscription = _async_to_generator(function(store, data, options) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                store.dispatch(subscriptionService.endpoints.updateSubscription.initiate(data, options))
            ];
        });
    });
    return _updateSubscription.apply(this, arguments);
}
function getSubscription(store, data, options) {
    return _getSubscription.apply(this, arguments);
}
function _getSubscription() {
    _getSubscription = (0,src_async_to_generator/* default */.Z)(function(store, data, options) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                store.dispatch(subscriptionService.endpoints.getSubscription.initiate(data, options))
            ];
        });
    });
    return _getSubscription.apply(this, arguments);
}
// END OF FUNCTION_EXPORTS
var useCreateSubscriptionMutation = subscriptionService /* Usage examples:
const { data, isLoading } = useGetSubscriptionsQuery({ id: 2 }, {}) //get hook
const [createSubscription, { isLoading, data, isSuccess }] = usecreateSubscriptionMutation() //create hook
subscriptionService.endpoints.getSubscriptions.select({id: 2})(store.getState()) //access data from any function
*/ .useCreateSubscriptionMutation, useGetSubscriptionQuery = subscriptionService.useGetSubscriptionQuery, useGetSubscriptionsQuery = subscriptionService.useGetSubscriptionsQuery, useUpdateSubscriptionMutation = subscriptionService.useUpdateSubscriptionMutation;


/***/ }),

/***/ 86773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toFormData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);


function toFormData(data) {
    var parentKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", formData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new FormData();
    if (typeof data === "string") {
        formData.append(parentKey, data);
    } else if (typeof data === "number") {
        formData.append(parentKey, data.toString());
    } else if (typeof data === "boolean") {
        formData.append(parentKey, data ? "true" : "false");
    } else if (data === null) {
    // formData.append(parentKey, 'null')
    } else if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data, Date)) {
        formData.append(parentKey, data.toISOString());
    } else if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data, File)) {
        formData.append(parentKey, data);
    } else if (data !== null && typeof data !== "undefined") {
        // Arrays and objects
        Object.entries(data).forEach(function(entry) {
            var _entry = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(entry, 2), key = _entry[0], value = _entry[1];
            toFormData(value, parentKey ? "".concat(parentKey, "[").concat(key, "]") : key.toString(), formData);
        });
    }
    return formData;
}


/***/ }),

/***/ 50135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(req, res) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, res), {
        currentPage: req.page || 1,
        pageSize: req.page_size,
        totalPages: Math.ceil(res.count / req.page_size)
    });
}


/***/ }),

/***/ 7061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pz": function() { return /* binding */ CustomerStatuses; },
/* harmony export */   "Up": function() { return /* binding */ convertSubscriptionToAPI; },
/* harmony export */   "Wm": function() { return /* binding */ convertShippingToAddress; },
/* harmony export */   "_$": function() { return /* binding */ BusinessType; },
/* harmony export */   "fS": function() { return /* binding */ getBillingPeriodDescription; },
/* harmony export */   "ji": function() { return /* binding */ convertAPISubscriptionToNormal; },
/* harmony export */   "ko": function() { return /* binding */ businessTypeDescriptions; },
/* harmony export */   "qL": function() { return /* binding */ convertAddressToShipping; },
/* harmony export */   "tv": function() { return /* binding */ BillingPeriod; }
/* harmony export */ });
/* unused harmony exports strings, APIBusinessType */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92903);
/* harmony import */ var common_project__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36877);



var CustomerStatuses = [
    "CANCELLED",
    "ACTIVE",
    "PENDING_CANCELLATION"
];
var BillingPeriod;
(function(BillingPeriod) {
    BillingPeriod[BillingPeriod["MONTHLY"] = 1] = "MONTHLY";
    BillingPeriod[BillingPeriod["ANNUAL"] = 2] = "ANNUAL";
})(BillingPeriod || (BillingPeriod = {}));
var getBillingPeriodDescription = function(v) {
    if (!v) {
        return null;
    }
    if (v === 1) {
        return "Monthly";
    } else {
        return "Annual";
    }
};
var convertAddressToShipping = function(address) {
    return {
        shipping_address_city: (address === null || address === void 0 ? void 0 : address.city) || "",
        shipping_address_country: (address === null || address === void 0 ? void 0 : address.country) || "",
        shipping_address_line_1: (address === null || address === void 0 ? void 0 : address.address_line_1) || "",
        shipping_address_line_2: (address === null || address === void 0 ? void 0 : address.address_line_2) || "",
        shipping_address_line_3: (address === null || address === void 0 ? void 0 : address.address_line_3) || "",
        shipping_address_postcode: (address === null || address === void 0 ? void 0 : address.postal_code) || ""
    };
};
var convertShippingToAddress = function(address) {
    return {
        address_line_1: (address === null || address === void 0 ? void 0 : address.shipping_address_line_1) || "",
        address_line_2: (address === null || address === void 0 ? void 0 : address.shipping_address_line_2) || "",
        address_line_3: (address === null || address === void 0 ? void 0 : address.shipping_address_line_3) || "",
        city: (address === null || address === void 0 ? void 0 : address.shipping_address_city) || "",
        country: (address === null || address === void 0 ? void 0 : address.shipping_address_country) || "",
        postal_code: (address === null || address === void 0 ? void 0 : address.shipping_address_postcode) || ""
    };
};
var BusinessType;
(function(BusinessType) {
    BusinessType["LIMITED_COMPANY"] = "LIMITED_COMPANY";
    BusinessType["SOLE_TRADER"] = "SOLE_TRADER";
    BusinessType["CHARITY"] = "CHARITY";
    BusinessType["UNINCORPORATED"] = "UNINCORPORATED";
    BusinessType["TRUST"] = "TRUST";
    BusinessType["ASSOCIATION"] = "ASSOCIATION";
})(BusinessType || (BusinessType = {}));


var strings = new react_localization__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z({
    en: {
        COMPANY_NUMBER: "Company Number",
        LIMITED_COMPANY: "Limited company (LTD, LP, LLP, LLC, Corp)"
    },
    "en-au": {
        COMPANY_NUMBER: "ABN/ACN",
        LIMITED_COMPANY: "Limited company (Pty Ltd, Ltd, LP)"
    }
});
//@ts-ignore
if (common_project__WEBPACK_IMPORTED_MODULE_2__/* .Project.language */ .I.language) {
    //@ts-ignore
    strings.setLanguage(common_project__WEBPACK_IMPORTED_MODULE_2__/* .Project.language */ .I.language);
}
var businessTypeDescriptions = {
    ASSOCIATION: "Association, club or society",
    CHARITY: "Charity / non-profit",
    LIMITED_COMPANY: strings.LIMITED_COMPANY,
    SOLE_TRADER: "Individual / sole trader",
    TRUST: "Trust, foundation or fund",
    UNINCORPORATED: "Unincorporated / not yet registered"
};
var APIBusinessType;
(function(APIBusinessType) {
    APIBusinessType[APIBusinessType["LIMITED_COMPANY"] = 1] = "LIMITED_COMPANY";
    APIBusinessType[APIBusinessType["SOLE_TRADER"] = 3] = "SOLE_TRADER";
    APIBusinessType[APIBusinessType["CHARITY"] = 10] = "CHARITY";
    APIBusinessType[APIBusinessType["UNINCORPORATED"] = 9] = "UNINCORPORATED";
    APIBusinessType[APIBusinessType["TRUST"] = 12] = "TRUST";
    APIBusinessType[APIBusinessType["ASSOCIATION"] = 13] = "ASSOCIATION";
})(APIBusinessType || (APIBusinessType = {}));
function getEnumKeyByValue(enumObject, value) {
    return Object.keys(enumObject).find(function(key) {
        return enumObject[key] === value;
    });
}
function convertSubscriptionToAPI(value) {
    return {
        "company": {
            "abn_number": value.abn_number,
            "acn_number": value.acn_number,
            "limited_company_number": value.company_number,
            "name": value.company_name,
            "organisation_type": APIBusinessType[value.business_type],
            "telephone_number": value.telephone_number,
            "trading_name": value.trading_name
        },
        "customer": {
            "email_address": value.email_address,
            "first_name": value.contact_first_name,
            "last_name": value.contact_last_name
        },
        external_id: value.external_id || undefined,
        groups: value.groups,
        "members": value.members,
        "product_id": value.plan_id,
        "shipping_address": {
            "shipping_address_city": value.address.city,
            "shipping_address_country": value.address.country,
            "shipping_address_line_1": value.address.address_line_1,
            "shipping_address_line_2": value.address.address_line_2,
            "shipping_address_line_3": value.address.address_line_3,
            "shipping_address_postcode": value.address.postal_code
        },
        status: "ACTIVE",
        "subscription": {
            "start_date": value.created_at || dayjs__WEBPACK_IMPORTED_MODULE_0___default()().format("YYYY-MM-DD")
        },
        subscription_id: value.id
    };
}
function convertAPISubscriptionToNormal(value) {
    var res = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, value), {
        abn_number: value.company.abn_number,
        acn_number: value.company.acn_number,
        address: {
            address_line_1: value.shipping_address.shipping_address_line_1,
            address_line_2: value.shipping_address.shipping_address_line_2,
            address_line_3: value.shipping_address.shipping_address_line_3,
            city: value.shipping_address.shipping_address_city,
            country: value.shipping_address.shipping_address_country,
            postal_code: value.shipping_address.shipping_address_postcode
        },
        business_type: getEnumKeyByValue(APIBusinessType, value.company.organisation_type),
        company_name: value.company.name,
        company_number: value.company.limited_company_number,
        contact_first_name: value.customer.first_name,
        contact_last_name: value.customer.last_name,
        created_at: value.subscription.start_date,
        email_address: value.customer.email_address,
        external_id: value.external_id,
        groups: value.groups,
        id: value.subscription_id,
        members: (value.members || []).map(function(v) {
            var ref, ref1, ref2;
            var kyc_id = (ref = v.documents) === null || ref === void 0 ? void 0 : ref.find(function(v) {
                return v.type === "ID";
            });
            var kyc_poa = (ref1 = v.documents) === null || ref1 === void 0 ? void 0 : ref1.find(function(v) {
                return v.type === "PROOF_OF_ADDRESS";
            });
            var audit_report = (ref2 = v.documents) === null || ref2 === void 0 ? void 0 : ref2.find(function(v) {
                return v.type === "AUDIT_REPORT";
            });
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, v), {
                audit_report: audit_report,
                kyc_id: kyc_id,
                kyc_poa: kyc_poa
            });
        }),
        plan_id: value.product_id,
        status: value.status,
        subscription: {
            end_date: value.subscription.end_date,
            start_date: value.subscription.start_date
        },
        telephone_number: value.company.telephone_number,
        trading_name: value.company.trading_name
    });
    return res;
}


/***/ }),

/***/ 73255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ camelCase; }
/* harmony export */ });
function camelCase(val) {
    // hello world > Hello world
    return val ? val.charAt(0).toUpperCase() + val.slice(1).toLowerCase() : "";
}


/***/ }),

/***/ 70752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ enumeration; }
/* harmony export */ });
/* harmony import */ var _camelCase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73255);

var enumeration = {
    get: function get(value) {
        // MY_CONSTANT > My constant
        if (!value) {
            return "";
        }
        return (0,_camelCase__WEBPACK_IMPORTED_MODULE_0__/* .camelCase */ .e)("".concat(value).replace(/_/g, " "));
    },
    set: function set(value) {
        // My Constant > MY_CONSTANT
        return value ? "".concat(value).replace(/ /g, "_").toUpperCase() : "";
    }
};


/***/ }),

/***/ 57384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ fromParam; },
  "i": function() { return /* binding */ toParam; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./common/utils/array/omit.ts

var omit = function(obj, keys) {
    var output = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
            if (!keys.includes(key)) {
                output.push([
                    key,
                    value
                ]);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Object.fromEntries(output);
};

;// CONCATENATED MODULE: ./common/utils/urls/param.ts


function fromParam(url) {
    // {min:100,max:200} <- ?min=100&max=200
    var documentSearch = typeof document === "undefined" ? "" : document.location.search;
    var str;
    if (url) {
        var split = url.split("/");
        str = split[split.length - 1];
    }
    if (!str && !documentSearch) {
        return {};
    }
    // eslint-disable-next-line
    var urlString = (str || documentSearch).replace(/(^\?)/, "");
    try {
        var params = new URLSearchParams(urlString);
        var entries = params.entries() //returns an iterator of decoded [key,value] tuples
        ;
        var result = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
                // each 'entry' is a [key, value] tupple
                result[key] = value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    } catch (e) {
        return {};
    }
}
function toParam(obj) {
    // {min:100,max:200} -> ?min=100&max=200
    if (!obj) return "";
    var allDefined = omit(obj, Object.keys(obj).filter(function(key) {
        return typeof obj[key] === "undefined" || obj[key] === null;
    }));
    return Object.keys(allDefined).map(function(k) {
        // @ts-ignore
        var val = allDefined[k];
        if (Array.isArray("array")) {
            val = val.join(",");
        }
        return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(val));
    }).join("&");
}


/***/ }),

/***/ 84376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


var themes = {
    danger: "bg-danger text-danger bg-opacity-10",
    info: "bg-info text-info bg-opacity-10",
    primary: "bg-primary text-primary bg-opacity-10",
    secondary: "bg-secondary text-secondary bg-opacity-10",
    success: "bg-success text-success bg-opacity-10",
    warning: "bg-warning text-warning bg-opacity-10"
};
var sizes = {
    counter: "badge--counter",
    default: "",
    dot: "badge--dot"
};
var Badge = function(param) {
    var children = param.children, className = param.className, size = param.size, _theme = param.theme, theme = _theme === void 0 ? "primary" : _theme;
    var themeClass = themes[theme];
    var sizeClass = size && sizes[size];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("badge fw-semibold d-flex fs-xs text-nowrap align-items-center justify-content-center text-center fs-xss", themeClass, sizeClass, className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Badge);


/***/ }),

/***/ 58086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


var ContentContainer = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("bg-white shadow-2 rounded-lg", className, {
            "px-5 py-4": !(className === null || className === void 0 ? void 0 : className.includes("p-"))
        }),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);


/***/ })

}]);